import React, { useEffect, useRef, useState } from "react";
import CompanyPageLayout from "./CompanyPageLayout";
import "./Contact.css";

const CONTACT_EMAIL = "contact@weavevo.com";

const REQUEST_TYPES = [
  "Enterprise Solutions",
  "Weave Integration",
  "Strategic Partnership",
  "Other",
];

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    companyName: "",
    jobTitle: "",
    type: "Enterprise Solutions",
  });
  const [typeOpen, setTypeOpen] = useState(false);
  const typeSelectRef = useRef(null);

  const updateField = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (!typeSelectRef.current?.contains(event.target)) setTypeOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setTypeOpen(false);
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  const selectType = (type) => {
    setForm((current) => ({ ...current, type }));
    setTypeOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const subject = form.type;
    const body = [
      `Name: ${form.name.trim()}`,
      `Business Email: ${form.email.trim()}`,
      `Company Name: ${form.companyName.trim()}`,
      `Job Title: ${form.jobTitle.trim()}`,
      `Type: ${form.type}`,
    ].join("\n");

    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <CompanyPageLayout pageTitle="Contact / Support" title="Contact / Support">
      <div className="wv-contactWrap">
        <section className="wv-contactInfo" aria-label="Contact Weavevo">
          <div className="wv-contactInfoGlow" aria-hidden="true" />

          <div className="wv-contactInfoTop">
            <div className="wv-contactIcon" aria-hidden="true">
              <span />
              <span />
              <span />
            </div>

            <h2>Integrating Living Weave for your business, scaling monetization, or exploring corporate solutions?</h2>
          </div>

          <a className="wv-contactEmail" href={`mailto:${CONTACT_EMAIL}`}>
            <span className="wv-contactEmailIcon" aria-hidden="true">@</span>
            <span>{CONTACT_EMAIL}</span>
            <span className="wv-contactEmailArrow" aria-hidden="true">↗</span>
          </a>
        </section>

        <form className="wv-contactForm" onSubmit={handleSubmit}>
          <div className="wv-contactGrid">
            <label className="wv-contactField">
              <span>Name</span>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={updateField}
                autoComplete="name"
                required
              />
            </label>

            <label className="wv-contactField">
              <span>Business Email</span>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={updateField}
                autoComplete="email"
                required
              />
            </label>

            <label className="wv-contactField">
              <span>Company Name</span>
              <input
                type="text"
                name="companyName"
                value={form.companyName}
                onChange={updateField}
                autoComplete="organization"
                required
              />
            </label>

            <label className="wv-contactField">
              <span>Job Title</span>
              <input
                type="text"
                name="jobTitle"
                value={form.jobTitle}
                onChange={updateField}
                autoComplete="organization-title"
                required
              />
            </label>
          </div>

          <div className="wv-contactType">
            <span className="wv-contactTypeLabel">Type</span>
            <div
              ref={typeSelectRef}
              className={`wv-contactSelect${typeOpen ? " is-open" : ""}`}
            >
              <button
                type="button"
                className="wv-contactSelectTrigger"
                aria-haspopup="listbox"
                aria-expanded={typeOpen}
                onClick={() => setTypeOpen((open) => !open)}
              >
                <span>{form.type}</span>
                <span className="wv-contactSelectChevron" aria-hidden="true" />
              </button>

              {typeOpen ? (
                <div className="wv-contactSelectMenu" role="listbox" aria-label="Type">
                  {REQUEST_TYPES.map((type) => {
                    const selected = form.type === type;
                    return (
                      <button
                        key={type}
                        type="button"
                        role="option"
                        aria-selected={selected}
                        className={`wv-contactSelectOption${selected ? " is-selected" : ""}`}
                        onClick={() => selectType(type)}
                      >
                        <span>{type}</span>
                        {selected ? <span className="wv-contactSelectCheck" aria-hidden="true">✓</span> : null}
                      </button>
                    );
                  })}
                </div>
              ) : null}
            </div>
          </div>

          <div className="wv-contactActions">
            <button type="submit" className="wv-contactSubmit">
              <span>Submit</span>
              <span className="wv-contactSubmitArrow" aria-hidden="true">↗</span>
            </button>
          </div>
        </form>
      </div>
    </CompanyPageLayout>
  );
}
